export const data = {
    menus: [
        {name: '首頁', code: 'home', route: 'home'},
        {name: '企業簡介', code: 'company', route: 'company'},
        {name: '產品介紹', code: 'product', route: 'product'},
        {name: '技術支持', code: 'patent', route: 'patent'},
        {name: '聯系我們', code: 'about', route: 'about'},
    ],

    productMenu:'產品介紹',
    home: {
        title1: '華仁健康',
        content1: '“華”取自於華夏文明、華夏民族，代表中華民族之生生不息;',
        content2: '“仁”取自儒家思想的核心，道德的最高原則;',
        content3: '“健康”來自賦予思想的生命延續，覆蓋所有物質、精神世界。',
    },

    company: {
        title1: '品牌起源',
        content1: ' <p>\n' +
        '                            從物種起源那壹刻起,“生命”踏上歷史舞臺。</p>\n' +
        '                        <p>人類，萬物生靈的壹支，經過進化式的繁衍生息得以存活。8000年前，華夏人在黃河流域開啟了華夏文明。生存被賦予了諸多要素，華夏文明、華夏民族可以延續，我們有了今天的生活。\n' +
        '                            生活離不開健康，健康涵蓋了生活的方方面面。</p>\n' +
        '                        <p>“健康”已經演變成對生活方式和生活態度的向往，是生活質量的象征。“健康”在財富之上，在靈魂之中，在時間之恒，在境界之勝，在道德之仁。</p>\n' +
        '                        <p>\n' +
        '                            “華仁健康”</p>\n' +
        '                        <p>“華”取自於華夏文明、華夏民族，代表中華民族之生生不息；</p>\n' +
        '                        <p>“仁”取自儒家思想的核心，道德的最高原則；</p>\n' +
        '                        <p>“健康”來自賦予思想的生命延續，覆蓋所有物質、精神世界。\n' +
        '\n' +
        '                        </p>',

        title2: '企業簡介',
        content2: '<p>\n' +
        '\n' +
        '                            河南華仁健康科技有限公司成立於2016年，坐落於鄭州高新技術開發區,是壹家專註於以“健康”為主線的各類產品的研發、生產、銷售及售後服務為壹體的高新技術密集型企業。</p>\n' +
        '                        <p>\n' +
        '                            公司產品以科學儀器、醫療檢測產品為基礎形成飲食健康系列、醫療健康系列。飲食健康系列分為食品、農產品、糧油、水質四種快速檢測方案、樣品前處理方案以及充分發揮農業科學的健康食品；醫療健康系涵蓋微量元素檢測儀、樣本稀釋液兩大類產品。公司擁有壹批在科學儀器與醫療檢測行業有數十年研發經驗和深刻理解的研發精英。在北京海澱區這塊極具科技底蘊的科技產品孵化園內擁有獨立研發中心。華仁健康公司銷售、服務體系遍布全國，由來自全國各地的科學儀器、醫療檢測資深銷售及服務人才組成。</p>\n' +
        '                        <p>\n' +
        '                            2018年初，公司與中國農業大學理學院建立戰略合作夥伴關系，成功引入國家級獲獎項目：農產品檢測樣品農藥殘留前處理過程中所需高效凈化柱（固相萃取柱）的生產。此項獨特前處理方法及其方法中的核心產品高效凈化柱的生產引入，成功填補了國內此項領域的空白。公司秉承“科學”、“人性化”的管理理念，建立了完整、高效的管理團隊，將研發、生產、銷售、計財有機融合。公司致力於全系產品的智能化、快速化和集成化，為民眾健康事業提供高效、便捷的產品和服務。\n' +
        '                        </p>'
    },

    product1: {
        title: 'Quick PRO ™系列凈化柱',
        content: " <p class=\"indent25\">\n" +
        "                        Quick PRO ™系列凈化柱產品源於中國農業大學潘燦平教授研究組科研成果的專利轉化，該研究組研究了多壁碳納米管等固相材料作為分散萃取的凈化效果，並首次開發出基於“QuEChERs”法的高效快捷的濾過型固相凈化方法（m-PFC法），在近百種農藥、多種獸藥、毒素和各種代表性基質上得到了驗證，方法參數如回收率、重現性、檢出限等方面能夠達到農藥殘留、獸藥殘留、毒素分析的要求。與經典的QuEChERS方法比較，在應用範圍、幹擾物質去除、基質效應、實驗成本等方面有明顯優勢。符合國標GB 23200.113-2018 食品安全國家標準 植物源性食品中208種農藥及其代謝物殘留量的測定  氣相色譜-質譜聯用法。\n" +
        "                    </p>\n" +
        "                    <p>Quick PRO ™系列凈化柱特點：\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\">\n" +
        "                        基於“QuEChERs”方法，華仁健康Quick PRO ™系列凈化柱100%轉化中國農業大學潘燦平教授研究組專利，此系列產品方便快速、特異性強、可靠性好、擴展性強性價比高等特點得到了廣大使用單位的好評。該產品有以下三大核心亮點：\n" +
        "                    </p>\n" +
        "                    <p>（1）擁有專利的濾過性凈化柱(m-pfc)濾過凈化形式\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\">\n" +
        "                        將QuEChERS方法中分散固相萃取中的吸附劑裝填至固相萃取柱管內，此類萃取柱為濾過性固相凈化柱（multiplug filtration clean-up,m-PFC）該方法可以顯著提高殘留分析方法前處理效率和凈化效果，為農、獸藥等痕量分析開拓了壹個新的研究方向，該方法在2015年獲得了國家發明專利證書。\n" +
        "                    </p>\n" +
        "                    <p>（2）多壁碳納米管（MWCNTs）\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\">\n" +
        "                        在吸附材料中加入修飾的多壁碳納米管（MWCNTs），具有較大的比表面積，凈化效果顯著優於傳統固相材料。同時將“QuEChERs”方法中的PSA、C18、弗羅裏矽土等多種吸附劑混合使用，使得對基質中的色素、有機酸、脂肪酸、碳水化合物等都有較好的吸附。\n" +
        "                    </p>\n" +
        "                    <p>（3）涵蓋性\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\">植物源性食品、動物源性食品如牛肉、豬肉、羊肉及腎臟、牛奶、雞蛋等\n" +
        "                    </p>\n" +
        "                    <p class=\"indent25\"> 分析目標物：農藥殘留、獸藥殘留，如氯黴素、磺胺類、阿維菌素類和毒素\n" +
        "                    </p>\n" +
        "                    <table class=\"pTable\">\n" +
        "                        <tr>\n" +
        "                            <td style=\"width: 150px;font-weight: 600;font-size: 14px;\">型號</td>\n" +
        "                            <td style=\"width: 450px;text-align: center;font-weight: 600;font-size: 14px;\">描述</td>\n" +
        "                            <td style=\"width: 100px;font-weight: 600;font-size: 14px;\">包裝</td>\n" +
        "                        </tr>\n" +
        "                        <tr>\n" +
        "                            <td>QuECHERS-PP</td>\n" +
        "                            <td>\n" +
        "                                <p>適用於含水量大、含糖量高、色素較低的簡單基質樣品中農藥殘留的檢測</p>\n" +
        "                                <p>適用樣品：蘋果、梨、桃、黃瓜、空心菜等</p>\n" +
        "                            </td>\n" +
        "                            <td>50支/盒 </td>\n" +
        "                        </tr>\n" +
        "                        <tr>\n" +
        "                            <td>QuECHERS-CP</td>\n" +
        "                            <td>\n" +
        "                                <p>適用於含有大量色素及幹擾物質的復雜基質樣品中農藥殘留的檢測</p>\n" +
        "                                <p>適用樣品：菠菜、韭菜、芹菜、茶葉、咖啡、土壤等</p>\n" +
        "                            </td>\n" +
        "                            <td>50支/盒 </td>\n" +
        "                        </tr>\n" +
        "                        <tr>\n" +
        "                            <td>QuECHERS-HF</td>\n" +
        "                            <td>\n" +
        "                                <p>適用於富含油脂、澱粉、蛋白質等的植物源樣品及各類動物源樣品中農藥殘留的檢測</p>\n" +
        "                                <p>適用樣品：大豆、花生、肉類、內臟、蛋類、水產品、乳制品等</p>\n" +
        "                            </td>\n" +
        "                            <td>50支/盒 </td>\n" +
        "                        </tr>\n" +
        "                        <tr>\n" +
        "                            <td>QuECHERS-VD</td>\n" +
        "                            <td>\n" +
        "                                <p>適用於動物源樣品中獸藥殘留的檢測</p>\n" +
        "                                <p>適用樣品：豬、牛、羊、家禽、水產品、乳制品等</p>\n" +
        "                            </td>\n" +
        "                            <td>50支/盒 </td>\n" +
        "                        </tr>\n" +
        "                    </table>\n" +
        "                    <div style=\"line-height: 10px;\">\n" +
        "                        <p> 應用領域 ：\n" +
        "                        </p>\n" +
        "                        <div style=\"padding-left: 25px;\">\n" +
        "                            <p> 食品所（檢測中心）：流通領域的食品中農藥殘留的檢測\n" +
        "                            </p>\n" +
        "                            <p> 農產品檢測中心：農產品農藥殘留的檢測\n" +
        "                            </p>\n" +
        "                            <p> 農業環境監測中心：農產品農藥殘留的檢測\n" +
        "                            </p>\n" +
        "                            <p> 畜產品檢測中心：畜產品中農藥殘留、獸藥殘留的檢測\n" +
        "                            </p>\n" +
        "                            <p> 水產品檢測中心：水產品中獸藥殘留的檢測\n" +
        "                            </p>\n" +
        "                            <p>CDC：食品、餐飲風險監控\n" +
        "                            </p>\n" +
        "                            <p>農科院、各類高校及科研院所：農藥殘留、獸藥殘留、毒素的檢測及科研\n" +
        "                            </p>\n" +
        "                            <p>糧油檢測中心：糧食中農藥殘留的檢測\n" +
        "                            </p>\n" +
        "                            <p>乳制品企業：乳制品中獸藥殘留的檢測\n" +
        "                            </p>\n" +
        "                            <p> 第三方檢測公司：各類型樣品的農藥殘留、獸藥殘留、毒素的檢測\n" +
        "                            </p></div>\n" +
        "                    </div>"
    },

    patent:{
        row1:'技術文檔下載',
        row2:'技術交流請致函：support@hrjktech.com'
    },
    product2: {
        building:'正在建設中，敬請期待',
        title: '樣本稀釋液產品',
        name1: '全血多元素檢測專用樣本稀釋液',
        content1: '微量元素檢測是通過原子吸收法儀器檢查檢查人體血液中微量元素的多少。現代科學研究證明，微量元素在人體中起著極其重要的作用，它的缺乏和過剩與人類的健康休戚相關。',

        name2: '全血鉛鎘元素檢測專用樣本稀釋液',
        content2: '少兒智力發育障礙及多動癥與人體中微量元素鉛、鎘關系密切；且營養不良兒童與銅、鋅、鈣、鎂、鐵元素缺乏有密切關系。'
    },

    products: [
        {name: '飲食健康', code: 'product1', route: 'product1'},
        {name: '醫療健康', code: 'product2', route: 'product2'}
    ],

    bottom: {
        address: '地址：中國河南鄭州高新技術產業開發區長椿路11號國家大學科技園C2-B3',
        phone: '聯系電話：86-371-63350191',
        email: '郵箱：support@hrjktech.com',
        company: '版權所有2018河南華仁健康科技有限公司保留壹切權利',
        no:'豫ICP備18031691號',
        yyzz: '營業執照',
        content:'經過兩年的建設和維護，河南華仁健康已經在全國建立了以北京為應用中心，鄭州為銷售中心的全國銷售、服務、應用支持網絡，網絡遍及吉林、遼寧、北京、天津、內蒙、山西、河北、河南、山東、安徽、江蘇、上海、浙江、湖北、湖南、江西、福建、廣東、廣西、海南、陜西、甘青寧、四川、雲南、貴州、西藏省、市、自治區。'
    },
    attrs: [{
        name: '凈化效果圖：視覺、回收率（農藥列表、獸藥）、圖譜.pdf',
        href: './static/1.pdf'
    },
        {
            name: '凈化柱不同基質前處理註意事項.pdf',
            href: './static/2.pdf'
        },
        {
            name: '凈化柱參考文獻.pdf',
            href: './static/3.pdf'
        },
        {
            name: 'QuickPRO系列凈化柱使用示意圖.pdf',
            href: './static/4.pdf'
        }]
}



// WEBPACK FOOTER //
// ./src/assets/data/zh_tw.js